import { type Chain } from 'viem'
import {
    apeChain as wagmiApeChain,
    arbitrum as wagmiArbitrum,
    avalanche as wagmiAvalanche,
    base as wagmiBase,
    blast as wagmiBlast,
    bsc as wagmiBsc,
    celo as wagmiCelo,
    mainnet as wagmiMainnet,
    mantle as wagmiMantle,
    mode as wagmiMode,
    opBNB as wagmiOpBNB,
    optimism as wagmiOptimism,
    polygon as wagmiPolygon,
    scroll as wagmiScroll,
} from 'wagmi/chains'
// Testnet imports
import { monadTestnet as wagmiMonadTestnet, sepolia as wagmiSepolia } from 'wagmi/chains'

import { wagmiBitcoin, wagmiMegaethTestnet, wagmiUnichain } from '@src/configs/customChains'
import { isFeatureEnabled } from '@src/utils/environment'

const wagmiChains = {
    mainnet: wagmiMainnet,
    optimism: wagmiOptimism,
    arbitrum: wagmiArbitrum,
    bsc: wagmiBsc,
    base: wagmiBase,
    avalanche: wagmiAvalanche,
    polygon: wagmiPolygon,
    celo: wagmiCelo,
    blast: wagmiBlast,
    scroll: wagmiScroll,
    mantle: wagmiMantle,
    mode: wagmiMode,
    opBNB: wagmiOpBNB,
    unichain: wagmiUnichain,
    bitcoin: wagmiBitcoin,
    apechain: wagmiApeChain,
    monadTestnet: wagmiMonadTestnet,
    sepolia: wagmiSepolia,
    megaethTestnet: wagmiMegaethTestnet,
}

const mainnetChains = [
    wagmiChains.mainnet,
    wagmiChains.optimism,
    wagmiChains.arbitrum,
    wagmiChains.bsc,
    wagmiChains.base,
    wagmiChains.avalanche,
    wagmiChains.polygon,
    wagmiChains.celo,
    wagmiChains.unichain,
    wagmiChains.bitcoin,
    ...(isFeatureEnabled('ENABLE_EXPERIMENTAL_CHAINS')
        ? [
              wagmiChains.blast,
              wagmiChains.scroll,
              wagmiChains.mantle,
              wagmiChains.mode,
              wagmiChains.opBNB,
              wagmiChains.apechain,
          ]
        : []),
] as Chain[]

export const enabledChains: Chain[] = ((): Chain[] => {
    if (isFeatureEnabled('USE_TESTNETS_ONLY')) {
        return [wagmiChains.sepolia as Chain, wagmiChains.monadTestnet as Chain, wagmiChains.megaethTestnet as Chain]
    } else {
        return isFeatureEnabled('ENABLE_TESTNETS')
            ? mainnetChains.concat([
                  wagmiChains.sepolia as Chain,
                  wagmiChains.monadTestnet as Chain,
                  wagmiChains.megaethTestnet as Chain,
              ])
            : mainnetChains
    }
})()

export const allChains: Chain[] = ((): Chain[] => {
    return Object.values(wagmiChains)
})()

if (enabledChains.length === 0) {
    throw new Error('At least one network must be configured')
}
